module.exports = __webpack_public_path__ + "static/media/vp-2.31afa6b1.png";